import type { QuestionAsset } from '../types'
import questionAssetManifest from '../../../../content/question-assets.json'

const workerUrl = import.meta.env.VITE_SANGMATH_API_URL?.replace(/\/$/, '')
const remoteAssetIds = new Set(
  questionAssetManifest.assets
    .filter(asset => asset.status === 'published')
    .map(asset => asset.id),
)

function assetUrl(assetId: string) {
  // New editorial assets are registered in the manifest and are served from
  // R2 through the Worker. Historical CeTZ exports still live on Pages until
  // their metadata and R2 objects are migrated, so retain their public path.
  if (workerUrl && remoteAssetIds.has(assetId)) return `${workerUrl}/assets/${encodeURIComponent(assetId)}`
  return `/assets/${encodeURIComponent(assetId)}`
}

type QuestionAssetsProps = {
  assets?: QuestionAsset[]
  placement: QuestionAsset['placement']
}

/** Renders only public, published assets from R2; answer data stays separate. */
export function QuestionAssets({ assets, placement }: QuestionAssetsProps) {
  const matching = assets?.filter(asset => asset.placement === placement) || []
  if (!matching.length) return null

  return (
    <section className="question-assets" aria-label={placement === 'passage' ? 'Hình minh họa của dữ kiện' : 'Hình minh họa của câu hỏi'}>
      {matching.map(asset => {
        const src = assetUrl(asset.assetId)
        return (
          <figure className="question-asset" key={asset.assetId}>
            {src ? (
              <a href={src} target="_blank" rel="noreferrer" className="question-asset-link" aria-label={`Mở rộng hình: ${asset.alt}`}>
                <img src={src} alt={asset.alt} loading="lazy" />
              </a>
            ) : (
              <div className="question-asset-unavailable" role="status">
                Hình sẽ hiển thị khi cấu hình Cloudflare Worker.
              </div>
            )}
            {asset.caption && <figcaption>{asset.caption}</figcaption>}
          </figure>
        )
      })}
    </section>
  )
}
